import { Component } from '@angular/core';
import { Meta } from '@angular/platform-browser';
import { COLOR_ACCENT_500 } from 'src/app/shared/constants/operationals';

@Component({
  selector: 'app-auth-signin',
  templateUrl: './auth-signin.component.html',
  styleUrls: ['./auth-signin.component.scss'],
})
export class AuthSigninComponent {
  constructor(private meta: Meta) {}

  ngOnInit(): void {
    this.meta.updateTag({ content: COLOR_ACCENT_500 }, 'name=theme-color');
  }
}
